module.exports = __webpack_public_path__ + "mobile/img/Outbound-img3.8ee58943.png";